const varMixin = {
    data: () => ({
        iconsList: [
            { text: "Apple", icon: "mdi-apple" },
            { text: "Chat", icon: "mdi-chat" },
            { text: "Cube", icon: "mdi-cube" },
            { text: "Database", icon: "mdi-database" },
            { text: "Email", icon: "mdi-email" },
            { text: "Folder", icon: "mdi-folder" },
            { text: "Group", icon: "mdi-account-group" },
            { text: "Home", icon: "mdi-home" },
            { text: "Home Account", icon: "mdi-home-account" },
            { text: "Lan", icon: "mdi-lan" },
            { text: "Laptop", icon: "mdi-laptop" },
            { text: "Linux", icon: "mdi-linux" },
            { text: "Lock", icon: "mdi-lock" },
            { text: "Map", icon: "mdi-map" },
            { text: "Server", icon: "mdi-server" },
            { text: "Settings", icon: "mdi-cog" },
            { text: "User", icon: "mdi-account" },
            { text: "Web", icon: "mdi-web" },
            { text: "Wifi", icon: "mdi-wifi" },
            { text: "Windows", icon: "mdi-microsoft-windows" },
        ],
    })
}

export default varMixin
